type LoadingUIProps = {
  parentClassName?: string;
  spinClassName?: string;
  labelClassName?: string;
};

/*
 * ローディングUI
 */
export default function LoadingUI({
  parentClassName = "min-h-screen",
  spinClassName = "size-12 ",
  labelClassName = "ml-3",
}: LoadingUIProps) {
  return (
    <div className={`flex items-center justify-center ${parentClassName}`}>
      <div className={`animate-spin rounded-full border-y-2 border-BLUE_1 ${spinClassName}`}></div>
      <span className={`text-BLUE_1 ${labelClassName}`}>読み込み中...</span>
    </div>
  );
}
